import React from 'react';
import {View} from 'react-native';
import {Dialog} from '@rn-vui/themed';

import Button from '../../components/themed/Button';
import Text from '../../components/ui-controls/Text';

const SignInRequiredModal = ({
  isVisible,
  onPress,
  onBackdropPress,
}: {
  isVisible: boolean;
  onPress: () => void;
  onBackdropPress: () => void;
}) => (
  <Dialog isVisible={isVisible} onBackdropPress={onBackdropPress}>
    <View testID="gift-card-sign-in-required-modal">
      <Text style={{marginBottom: 16, textAlign: 'center'}}>
        TO PLACE AN ORDER YOU NEED TO SIGN IN OR CREATE AN ACCOUNT
      </Text>
      <Button
        onPress={onPress}
        title="SIGN IN OR CREATE AN ACCOUNT"
        buttonStyle={{width: '100%'}}
      />
      {/* </Dialog.Actions> */}
    </View>
  </Dialog>
);

export default SignInRequiredModal;
